import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "io-section-contact" }
const _hoisted_2 = { class: "io-section-contact__nav" }
const _hoisted_3 = { class: "container-fluid" }
const _hoisted_4 = { ref: "navRow" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = { class: "io-section-contact__content" }
const _hoisted_7 = ["id"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FaIcon = _resolveComponent("FaIcon")!
  const _component_GridCol = _resolveComponent("GridCol")!
  const _component_GridRow = _resolveComponent("GridRow")!
  const _component_IoSpacer = _resolveComponent("IoSpacer")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.contactOptionsAll, (contactOption) => {
            return (_openBlock(), _createElementBlock("div", {
              key: `io-section-contact__nav-${contactOption.id}`,
              class: _normalizeClass({ 'active': _ctx.activeOptionId === contactOption.id }),
              onClick: ($event: any) => (_ctx.changeActiveOptionId(contactOption.id))
            }, [
              _createVNode(_component_GridRow, {
                g: "0",
                center: ""
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_GridCol, {
                    s: "auto",
                    "vertical-center": ""
                  }, {
                    default: _withCtx(() => [
                      (contactOption.icon.indexOf('fa') < 0)
                        ? (_openBlock(), _createBlock(_resolveDynamicComponent(`Icon${contactOption.icon.charAt(0).toUpperCase() + contactOption.icon.slice(1)}`), { key: 0 }))
                        : _createCommentVNode("", true),
                      (contactOption.icon.indexOf('fa') >= 0)
                        ? (_openBlock(), _createBlock(_component_FaIcon, {
                            key: 1,
                            icon: contactOption.icon
                          }, null, 8, ["icon"]))
                        : _createCommentVNode("", true)
                    ]),
                    _: 2
                  }, 1024),
                  _createVNode(_component_GridCol, {
                    s: "auto",
                    "vertical-center": ""
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(contactOption.title), 1)
                    ]),
                    _: 2
                  }, 1024)
                ]),
                _: 2
              }, 1024)
            ], 10, _hoisted_5))
          }), 128))
        ], 512)
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      (_ctx.activeOption)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            id: `contact-option-${_ctx.activeOption.id}`
          }, [
            _createVNode(_component_IoSpacer, { size: "large" }),
            (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.activeContent.component))),
            _createVNode(_component_IoSpacer, { size: "large" })
          ], 8, _hoisted_7))
        : _createCommentVNode("", true)
    ])
  ]))
}